import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import StatsSection from "@/components/StatsSection";
import FeatureCardsSection from "@/components/FeatureCardsSection";
import AktuellesSection from "@/components/AktuellesSection";
import TransformationSection from "@/components/TransformationSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import WhySection from "@/components/WhySection";
import TrustBadgesSection from "@/components/TrustBadgesSection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { KURSE_TEXT } from "@/config/webseiteFakten";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="MusiKonzept – Online-Akademie für Musikpädagogik"
        description={`Online-Akademie für pädagogische Fachkräfte: ${KURSE_TEXT} für die Praxis, KI-gestützte Lernbegleitung durch Miko und Ausbildungen in Musikpädagogik.`}
        path="/"
      />
      <Header />
      <main>
        <HeroSection />
        <StatsSection />
        <AktuellesSection />
        <TransformationSection />
        <FeatureCardsSection />
        <TestimonialsSection />
        <WhySection />
        <TrustBadgesSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
